import React, { useEffect } from 'react';
import Dialog from "../../components/controls/Dialog";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import * as llmProviderService from '../../services/llmProviderService';
import Input from '../../components/controls/Input';
import { useForm } from '../../components/useForm';
import useAlert from '../../components/useAlert';

const initialFValues = {
    id: '',
    name: ''
}

const LlmProviderDialog = (props) => {
    const { open, selectedRow, getLlmProviders } = props;

    const {
        values,
        setValues,
        errors,
        handleInputChange,
        handleClose,
        handleError
    } = useForm(initialFValues, props);

    useEffect(() => {
        if (open)
            handleAlertClose();
        if (selectedRow)
            setValues({
                ...selectedRow
            });
        else
            setValues(initialFValues);
        //eslint-disable-next-line
    }, [selectedRow, open])

    const {
        Alert,
        status,
        showSuccess,
        showError,
        handleAlertClose
    } = useAlert();

    const submit = () => {
        if (validate()) {
            if (selectedRow)
                llmProviderService.updateLlmProvider(selectedRow.id, values)
                    .then(() => {
                        showSuccess();
                        handleClose();
                        getLlmProviders();
                    })
                    .catch(error => {
                        showError(error.response.data.message);
                        handleError(error.response.data.fields);
                    });
            else
                llmProviderService.createLlmProvider(values)
                    .then(() => {
                        showSuccess();
                        handleClose();
                        getLlmProviders();
                    })
                    .catch(error => {
                        showError(error.response.data.message);
                        handleError(error.response.data.fields);
                    });
        }
    };

    const validate = () => {
        let temp = {}
        temp.id = values.id ? "" : "ID is required";
        temp.name = values.name ? "" : "Name is required";
        // You can add more validation if needed
        return Object.values(temp).every(x => x === '');
    }

    return (
        <React.Fragment>
            {status ? <Alert /> : null}
            <Dialog
                title={selectedRow ? "Edit LLM Provider" : "Create new LLM Provider"}
                open={open}
                handleClose={handleClose}>
                <DialogContent>
                    <Input
                        {...(selectedRow && { disabled: true })}
                        label="Provider ID"
                        name="id"
                        defValue={values.id}
                        onChange={handleInputChange}
                        error={errors.id}
                    />
                    <Input
                        label="Provider Name"
                        name="name"
                        defValue={values.name}
                        onChange={handleInputChange}
                        error={errors.name}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={submit}>Save</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default LlmProviderDialog;
